import { render } from "./system-banner-list.vue?vue&type=template&id=28500141&scoped=true"
import script from "./system-banner-list.vue?vue&type=script&lang=js"
export * from "./system-banner-list.vue?vue&type=script&lang=js"

import "./system-banner-list.vue?vue&type=style&index=0&id=28500141&scoped=true&lang=css"

import exportComponent from "/home/aaicom7/repositories/prod/AAI-FMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28500141"]])

export default __exports__